var progress = require('_core_ext/progress'),
    page = require('_core_ext/page'),
    util = require('_core_ext/util');

var currentRequests = [];

/**
 * @function
 * @description Ajax request to get json response
 * @param {Boolean} async  Asynchronous or not
 * @param {String} url URI for the request
 * @param {Object} data Name/Value pair data request
 * @param {Function} callback  Callback function to be called
 * @returns {jqXHR|Promise} jqXHR object if request started, or rejected w/o arguments jQuery Promise object if no url passed or same request already in progress.
 */
var getJson = function (options) {
    options.url = util.toAbsoluteUrl(options.url);
    // return if no url exists or url matches a current request
    if (!options.url || currentRequests[options.url]) {
        return $.Deferred().reject().promise();
    }

    currentRequests[options.url] = true;

    // make the server call
    return $.ajax({
        dataType: options.dataType || 'json',
        url: options.url,
        async: (typeof options.async === 'undefined' || options.async === null) ? true : options.async,
        data: options.data || {}
    })
    // success
    .done(function (response) {
        if (options.callback) {
            options.callback(response);
        }
    })
    // failed
    .fail(function (xhr, textStatus) {
        if (textStatus === 'parsererror') {
            window.alert(Resources.BAD_RESPONSE);
        }
        if (options.callback) {
            var responseText = xhr.responseText;
            options.callback(null, textStatus, responseText);
        }
    })

    // executed on success or fail
    .always(function () {
        // remove current request from hash
        if (currentRequests[options.url]) {
            delete currentRequests[options.url];
        }
    });
};
/**
 * @function
 * @description ajax request to load html response in a given container
 * @param {String} url URI for the request
 * @param {Object} data Name/Value pair data request
 * @param {Function} callback  Callback function to be called
 * @param {Object} target Selector or element that will receive content
 */
var load = function (options) {
    options.url = util.toAbsoluteUrl(options.url);
    // return if no url exists or url matches a current request
    if (!options.url || currentRequests[options.url]) {
        return;
    }

    currentRequests[options.url] = true;

    // make the server call
    return $.ajax($.extend(true, {
        dataType: 'html',
        method: 'GET',
        xhrFields: {
            withCredentials: true
        }
    }, options, {
        url: util.appendParamToURL(options.url, 'format', 'ajax')   // append format=ajax only when passing to $.ajax
    }))
    .then(function (response, textStatus, jqXHR) {
        if (jqXHR.getResponseHeader('X-SF-CC-Redirected-To')) {
            // presense of this header means that we received full Login page in reply to ajax,
            // so do redirect to it and return empty string to prevent inserting full page content by subsequent handler(s)
            page.redirect(jqXHR.getResponseHeader('X-SF-CC-Redirected-To'));
            return '';
        }

        // success
        if (options.target) {
            $(options.target).empty().html(response);
        }
        if (options.callback) {
            options.callback(response);
        }
        return response;
    })
    .fail(function (xhr, textStatus) {
        // failed
        if (textStatus === 'parsererror') {
            window.alert(Resources.BAD_RESPONSE);
        }
        if (options.callback) {
            options.callback(null, textStatus);
        }
    })
    .always(function () {
        progress.hide();
        // remove current request from hash
        if (currentRequests[options.url]) {
            delete currentRequests[options.url];
        }
    });
};

exports.getJson = getJson;
exports.load = load;
